'use server';
// App-side auth re-export: the package performs sign-in/out over supabase.auth; we inject the
// revalidate paths (the View/Model split — the LoginForm block takes onSubmit, the data kit performs it).
import { signIn as authSignIn, signOut as authSignOut } from '@santiagossz/app-kit/data';

export async function signIn(input: { email: string; password: string }): Promise<void> {
  await authSignIn(input, { revalidate: ['/'] });
}

export async function signOut(): Promise<void> {
  await authSignOut({ revalidate: ['/'] });
}
